export default __webpack_public_path__ + "static/media/6.8c0b9f66.png";